import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgTouristAttraction(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V8L4.58914 7.99999C4.32418 7.99999 4.07005 8.10515 3.88255 8.29237L1.58475 10.5868C0.804274 11.3684 0.805203 12.6348 1.58682 13.4152L3.88255 15.7076C4.07005 15.8948 4.32418 16 4.58914 16L11 16V20H9.5C8.94772 20 8.49999 20.4477 8.49999 21C8.49999 21.5523 8.94772 22 9.5 22H14.5C15.0523 22 15.5 21.5523 15.5 21C15.5 20.4477 15.0523 20 14.5 20H13V12L19.4097 12C19.6746 12 19.9288 11.8948 20.1163 11.7076L22.412 9.41524C23.1936 8.63476 23.1945 7.36843 22.4141 6.58681L20.1163 4.29237C19.9288 4.10515 19.6746 3.99999 19.4097 3.99999L13 4V3Z", fill: "currentColor" })));
}
export default SvgTouristAttraction;
